import actions from './actions'

const ADMIN = 'clinic_admin'
const FOUNDER = 'root'
const REGISTRY = 'registrar'
const DOCTOR = 'doctor'
const DOCTOR_ADMIN = 'doctor_admin'
const SERVICE_STAFF = 'service_staff'
const DEVICE = 'device'
const CLIENT = 'client'

export default {
	namespaced: true,
	actions
}



// WEBPACK FOOTER //
// ./src/vuex/services/role/index.js